<template>
  <div
    v-if="loading"
    class="d-flex align-center justify-center"
    style="height: 100%;"
  >
    <v-progress-circular
      indeterminate
      color="primary"
    />
  </div>
  <v-list
    v-else
    :style="{ height: 'calc(100vh - 64px)', overflowX: 'scroll' }"
  >
    <v-list-item
      v-if="title"
    >
      <v-list-item-icon>
        <v-icon
          color="blue-grey"
        >
          mdi-school
        </v-icon>
      </v-list-item-icon>
      <v-list-item-title>
        <h1 class="blue-grey--text">
          {{ title }}
        </h1>
      </v-list-item-title>
    </v-list-item>
    <v-list-item>
      <v-list-item-content
        class="help-content text-subtitle-1"
        v-html="content"
      />
    </v-list-item>
  </v-list>
</template>

<script>
import { mapGetters } from 'vuex';
import url from '../../../utils/url';

export default {
  name: 'HelpContent',
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      helpContent: {},
      loading: false,
    };
  },
  watch: {
    open() {
      if (this.open) {
        this.loadHelp(this.$route.name);
      }
    },
  },
  computed: {
    ...mapGetters(['user', 'language']),
    title() {
      const { name } = this.$route;
      const content = this.helpContent;
      if (content.hasOwnProperty(name)) {
        const languages = content[name].hasOwnProperty('acf') && content[name].acf.hasOwnProperty('languages') ? content[name].acf.languages : [];
        const language = languages.find(({ language_code }) => language_code === this.language);
        if (language && language.title) {
          return language.title;
        }
        return content[name].title.rendered || '';
      }
      return '';
    },
    content() {
      const { name } = this.$route;
      const content = this.helpContent;
      if (content.hasOwnProperty(name)) {
        const languages = content[name].hasOwnProperty('acf') && content[name].acf.hasOwnProperty('languages') ? content[name].acf.languages : [];
        const language = languages.find(({ language_code }) => language_code === this.language);
        if (language && language.content) {
          return language.content;
        }
        return content[name].content.rendered || this.$t('common.help_missing');
      }
      return this.$t('common.help_missing');
    },
  },
  methods: {
    async loadHelp(slug) {
      if (this.helpContent.hasOwnProperty(slug)) return;
      try {
        this.loading = true;
        const { data, status } = await this.http.get(
          url`https://help.diligence.cloud/wp-json/wp/v2/pages?slug=${slug}`,
          { auth: false },
        );
        if (status === 200 && Array.isArray(data) && data.length) {
          this.$set(this.helpContent, slug, data[0]);
        }
      } catch (e) {
        // @TODO: Handle help errors here
        // eslint-disable-next-line no-console
        console.error(`Failed to load help content for page ${slug}`, e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
